import { Avatar, Grid } from '@mui/material';
import { deepOrange } from '@mui/material/colors';
import { getInitials } from '../utils';
import { UserDto } from './PricePrgClient';

type Props = {
    user: Pick<UserDto, 'fullName' | 'profileIconUrl'>;
    iconOnly: boolean;
    namePlacement?: 'start' | 'end';
};

export const UserAvatar = ({ user, iconOnly, namePlacement }: Props) => {
    const avatar = (
        <Avatar
            alt={user.fullName}
            src={user.profileIconUrl}
            sx={theme => ({
                orange: {
                    color: theme.palette.getContrastText(deepOrange[500]),
                    backgroundColor: deepOrange[500]
                }
            })}
        >
            {getInitials(user.fullName)}
        </Avatar>
    );

    if (iconOnly) {
        return avatar;
    }

    let gridItems = [
        <Grid item key={0}>
            {avatar}
        </Grid>,
        <Grid item key={1}>
            {user.fullName}
        </Grid>
    ];

    if (namePlacement === 'start') {
        gridItems = gridItems.reverse();
    }

    return (
        <Grid container direction="row" spacing={2} alignItems="center">
            {gridItems}
        </Grid>
    );
};
